import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="bottom-sheet"
export default class extends Controller {
  static targets = ["backdrop", "panel"];

  connect() {
    // 1. Lock the body scroll so the background video doesn't scroll
    document.body.style.overflow = "hidden";

    // 2. Trigger the slide-up animation 10ms after connection
    setTimeout(() => {
      this.backdropTarget.classList.remove("opacity-0");
      this.panelTarget.classList.remove("translate-y-full");
    }, 10);
  }

  disconnect() {
    // Release the body scroll when destroyed
    document.body.style.overflow = "";
  }

  close() {
    // 1. Animate out
    this.backdropTarget.classList.add("opacity-0");
    this.panelTarget.classList.add("translate-y-full");

    // 2. Wait for the CSS transition to finish (300ms), then clear the Turbo Frame
    setTimeout(() => {
      this.element.remove();
    }, 300);
  }
}
